export default "__VITE_ASSET__c3959ed7__"